export default __webpack_public_path__ + "static/media/headphones.e663e651.png";